export const ADMIN_USERS = [
	{id: 3, email: 'zzp.zaza@eitje.appp'},
	{id: 287, email: 'admin@eitje-app.nl'},
	{id: 394, email: 'baaz@bazen.nl'},
	{id: 7187, email: 'jurriaan@eitje.app'},
	{id: 45532, email: 'tiemo_admin@eitje.appp'},
	{id: 45531, email: 'clara_admin@eitje.appp'},
]

export const ROLES = {
	manager: 'manager',
	contracts: 'contracten',
	financial: 'financieel',
	leave: 'verlof',
	writeHours: 'uren_schrijven',
	approveHours: 'uren_accorderen',
	admin: 'admin',
	unschedulable: 'onroosterbaar',
}

export const ALL_ROLES = [ROLES.manager, ROLES.contracts, ROLES.financial, ROLES.leave, ROLES.writeHours, ROLES.approveHours, ROLES.admin]
